import { render, staticRenderFns } from "./VideoRoom.vue?vue&type=template&id=2afe2d4e&"
import script from "./VideoRoom.vue?vue&type=script&lang=js&"
export * from "./VideoRoom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports